const icons = {
    400: "info",
    406: "info"
};

const titles = {
    400: "Revisa la información",
    403: "Error en permisos",
    406: "Operación NO permitida",
    500: "Error interno en el servidor"
};

let sessionExpiredRedirecting = false;

export const isSessionExpiredRedirecting = () => sessionExpiredRedirecting;

export const parseErrorAxios = (errorAxios) => {
    console.error("Error Axios 🎃 %o", errorAxios);
    if (typeof errorAxios === "string") {
        return {
            message: errorAxios,
            statusCode: 500,
            icon: "error",
            title: "Error 😥😣"
        };
    }
    let parseError = {
        message: "Internal error / Network error",
        statusCode: 100,
        icon: "error",
        title: "Error 😥😣"
    };
    if ("response" in errorAxios && !!errorAxios.response) {
        const status = errorAxios.response.status || 500;
        const body = errorAxios.response.data;
        parseError = {
            message:
                typeof body === "string"
                    ? body
                    : "error" in body
                    ? body.error
                    : JSON.stringify(body),
            statusCode: status,
            icon: icons[status] || "error",
            title: titles[status] || `Error código ${status}`,
            // Errores de negocio con datos estructurados (ej. PLAN_LIMIT_REACHED).
            ...(body && typeof body === "object" && body.code
                ? { code: body.code, data: body.data }
                : {})
        };
    }
    return parseError;
};

export const PLAN_LIMIT_REACHED = "PLAN_LIMIT_REACHED";

export const isPlanLimitError = (error) =>
    Boolean(error) &&
    error.statusCode === 422 &&
    error.code === PLAN_LIMIT_REACHED;

export const CATALOG_VERSION_LOCKED = "CATALOG_VERSION_LOCKED";

export const isCatalogVersionLockedError = (error) =>
    Boolean(error) &&
    error.statusCode === 422 &&
    error.code === CATALOG_VERSION_LOCKED;

export const DISPLAY_MODE_SEGMENTS_INVALID = "DISPLAY_MODE_SEGMENTS_INVALID";

export const isDisplayModeSegmentsInvalidError = (error) =>
    Boolean(error) &&
    error.statusCode === 422 &&
    error.code === DISPLAY_MODE_SEGMENTS_INVALID;

export const handleErrorAxios = (errorAxios, dispatch, redirect = true) => {
    const parseError = parseErrorAxios(errorAxios);

    if (!redirect) {
        return parseError;
    }

    if ([401, 412].includes(parseError.statusCode)) {
        sessionExpiredRedirecting = true;
        dispatch(
            "commons/setPostLoginRedirect",
            `${window.location.pathname}${window.location.search}`,
            { root: true }
        );
        dispatch("auth/signOut", {}, { root: true });
        location.href = "/expired";
    }

    if ([428, 502].includes(parseError.statusCode)) {
        dispatch("auth/signOut", {}, { root: true });
        location.href = `/error?statusCode=${parseError.statusCode}&message=${parseError.message}`;
    }
    return parseError;
};
